import { MenuSource } from '@packages/charka-common-ui/graphql/types/graphql';

const menuSources = [MenuSource.Restaurant, MenuSource.DigitalMenu];

export function convertStringToMenuSource(service: string) {
  return menuSources.find((source) =>
    source.toLowerCase().split('_').join('').includes(mappingServiceToMenuSource(service))
  );
}

function mappingServiceToMenuSource(service: string) {
  if ('onlineorder'.includes(service.toLowerCase())) {
    return 'restaurant';
  }
  return 'digitalmenu';
}
